module.exports = __webpack_public_path__ + "5953794d52098c7c2c3492c1f637b02e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icons/icons.svg?edd5f759e39cf0af8ed039b31ef6e852
// module id = 350
// module chunks = 0